import urlcat from 'urlcat';
import type { AxiosRequestConfig } from 'axios';
import type { CampaignReporting as CampaignReportingModel, ModuleConstructorProps } from '../Types';
import { BaseEntityModuleFuncs } from './BaseEntityModuleFuncs';

const CampaignReporting = ({ endpoints, httpClient, baseUrl }: ModuleConstructorProps) => ({
    ...BaseEntityModuleFuncs<CampaignReportingModel>(
        { endpoints, httpClient, baseUrl },
        'CampaignReporting',
    ),
    /**
     * Assign this configuration to users / agencies / buyers / clients / owners.
     * An omitted key leaves that relation untouched; an empty array clears it.
     */
    attach: (
        {
            configId,
            users,
            agencies,
            buyers,
            clients,
            owners,
        }: {
            configId: number;
            users?: number[];
            agencies?: number[];
            buyers?: number[];
            clients?: number[];
            owners?: number[];
        },
        config?: AxiosRequestConfig,
    ) => {
        const data = {
            ...(users != null && { users }),
            ...(agencies != null && { agencies }),
            ...(buyers != null && { buyers }),
            ...(clients != null && { clients }),
            ...(owners != null && { owners }),
        };

        return httpClient.post<{ data: CampaignReportingModel }>(
            urlcat(endpoints.Entities.CampaignReporting.attach, { id: configId }),
            data,
            config,
        );
    },
});

export default CampaignReporting;
